import React, { useContext } from 'react';
import classes from './MenuCardSticker.module.scss';
import { GeneralContext } from '../../../../context/generalContext';

function MenuCardSticker({ color, name, name_en }) {
  const { activeLanguage } = useContext(GeneralContext);
  return (
    <div
      className={classes.sticker}
      style={{
        background: color,
      }}
    >
      {activeLanguage === 1 ? name : name_en || name}
    </div>
  );
}

export default MenuCardSticker;
